export async function setupMsw(): Promise<void> {
  if (import.meta.env.VITE_MOCK_API !== 'true') {
    return;
  }

  const [{ setupWorker }, { mockApiHandlers }] = await Promise.all([
    import('msw/browser'),
    import('./mockApi'),
  ]);

  const worker = setupWorker(...mockApiHandlers);

  await worker.start({
    onUnhandledRequest: 'bypass',
  });
}
